import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { openFinanceService, type ProviderAccountType } from '../services/open-finance.service';

const KEY = 'open-finance';

export function useOpenFinanceAccounts(enabled: boolean, type?: ProviderAccountType) {
  return useQuery({
    queryKey: [KEY, 'accounts', type ?? 'todas'],
    queryFn: () => openFinanceService.accounts(type),
    enabled,
    retry: false,
  });
}

export function useOpenFinanceStatus() {
  return useQuery({ queryKey: [KEY, 'status'], queryFn: openFinanceService.status });
}

export function useOpenFinanceSync() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: openFinanceService.sync,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [KEY] });
      qc.invalidateQueries({ queryKey: ['bank-imports'] });
      // A busca também traz as faturas fechadas dos cartões vinculados (2D).
      qc.invalidateQueries({ queryKey: ['card-invoices'] });
      qc.invalidateQueries({ queryKey: ['credit-cards'] });
    },
  });
}
